export default __webpack_public_path__ + "static/media/user-alt.ef4c8de0.svg";